import GoogleTagManager from '@redux-beacon/google-tag-manager'
import { eventsMap } from 'analytics/eventsMap'
import { appRouterMiddleware } from 'lib/routing/appRouting'
import userMiddleware from 'middlewares/userMiddleware'
import { createMiddleware } from 'redux-beacon'
import buildStore from './store'
import { analyticsListenerMiddleware } from 'middlewares/analyticsMiddleware'
import analyticsPageViewMiddleware from 'middlewares/analyticsPageViewMiddleware'
import { offerComparisonPersistenceMiddleware } from 'middlewares/offerComparisonPersistenceMiddleware'
import promoReapplicationMiddleware from 'middlewares/promoReapplicationMiddleware'
import merchandiseShippingCacheMiddleware from 'middlewares/merchandiseShippingCacheMiddleware'
import { historicalActionsPersistenceMiddleware } from 'middlewares/historicalActionsPersistenceMiddleware'
import actionRecorderMiddleware from 'middlewares/actionRecorderMiddleware'
import regionChannelSettingsMiddleware from 'middlewares/regionChannelSettingsMiddleware'
import experimentPanelPersistenceMiddleware from 'middlewares/experimentPanelPersistenceMiddleware'

function initialiseStore(history: any, initialState: App.State) {
  const googleTagManagerMiddleware = createMiddleware(
    eventsMap,
    GoogleTagManager(),
  )

  const middlewares = [
    userMiddleware,
    appRouterMiddleware(history),
    googleTagManagerMiddleware,
    analyticsListenerMiddleware.middleware,
    analyticsPageViewMiddleware.middleware,
    offerComparisonPersistenceMiddleware.middleware,
    historicalActionsPersistenceMiddleware.middleware,
    promoReapplicationMiddleware.middleware,
    merchandiseShippingCacheMiddleware,
    actionRecorderMiddleware,
    regionChannelSettingsMiddleware.middleware,
    experimentPanelPersistenceMiddleware,
  ]

  const store = buildStore(
    history,
    initialState,
    middlewares,
  )

  return store
}

export default initialiseStore
